import { useCurrentRefinements } from "react-instantsearch";
import React from "react";
import styled from "styled-components";
import { map } from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import { useSearchPageContext } from "../../components/pages/SearchPage/SearchPageContext";
import { humanizeDealsLabel } from "../../components/pages/SearchPage/components/SearchFilters";
import FlexBox from "../../components/elements/v2/Box/FlexBox";
import { BUTTON_SIZES, OutlineButton } from "../../components/elements/v2/Button/Button";
import { breakpoints } from "../styledHelpers";
import stringHumanize from "string-humanize";
import { categoryAttributeLevel0 } from "./categoryHierarchy";
import { filterSizesByCountry } from "../listingHelper";
import ConditionalDisplay from "../../components/elements/ConditionalDisplay";

function displaySelectedFilterValue(attribute: string, label: string, countryCode?: string) {
  if (attribute === "material" || attribute === "style") return label.replace(/\|/g, " - ");
  if (attribute === "price_reduced_percentage_bucket") return humanizeDealsLabel(label);
  if (attribute === "price_aud") return `Price ${label}`;
  if (attribute === "condition") return stringHumanize(label);
  if (attribute === categoryAttributeLevel0)
    return label
      .split(" > ")
      .map((s) => stringHumanize(s))
      .join(" > ");
  if (attribute === "size")
    return [label.split("|")[0], filterSizesByCountry(label, countryCode)].join(" > ");
  if (attribute === "adaptive") return "Adaptive";

  return label;
}

export default function ActiveRefinements() {
  const { myCountry, longTailPage } = useSearchPageContext();
  const { items, canRefine, refine } = useCurrentRefinements();

  if (longTailPage) return null;

  const refinements = items.map((item) => item.refinements).flat();

  return (
    <ConditionalDisplay hidden={!canRefine}>
      <Tags>
        {map(refinements, (refinement) => (
          <Tag key={refinement.value} endIcon={<CloseIcon />} onClick={() => refine(refinement)}>
            {displaySelectedFilterValue(refinement.attribute, refinement.label, myCountry?.code)}
          </Tag>
        ))}
      </Tags>
    </ConditionalDisplay>
  );
}

const Tags = styled(FlexBox)`
  padding-top: 16px;
  padding-bottom: 16px;
  gap: 8px;
  flex-wrap: wrap;
  ${breakpoints.up("tablet")} {
    padding: 0;
  }
`;

const Tag = styled(OutlineButton).attrs({
  size: BUTTON_SIZES.SMALL,
})`
  text-transform: initial;
  min-height: 32px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
`;
